import React from 'react';
import { ChevronDown } from 'lucide-react';

const SORT_OPTIONS = [
  { value: '', label: 'Pertinence' },
  { value: 'nom_asc', label: 'Nom A→Z' },
  { value: 'nom_desc', label: 'Nom Z→A' },
  { value: 'prix_asc', label: 'Prix croissant' },
  { value: 'prix_desc', label: 'Prix décroissant' },
  { value: 'date_sortie_desc', label: 'Date de sortie' },
];

/**
 * ResultsHeader — Compteur résultats + tri (Phase 3.4)
 */
export default function ResultsHeader({ total, sort, onSortChange, loading }) {
  return (
    <div className="flex items-center justify-between py-2" data-testid="results-header">
      <span className="text-sm text-gray-600">
        {loading ? (
          <span className="inline-flex items-center gap-1.5">
            <span className="h-3 w-3 border-2 border-gray-300 border-t-gray-600 rounded-full animate-spin" />
            Chargement...
          </span>
        ) : (
          <>{total} produit{total !== 1 ? 's' : ''} trouvé{total !== 1 ? 's' : ''}</>
        )}
      </span>
      <div className="relative">
        <select
          value={sort}
          onChange={e => onSortChange(e.target.value)}
          className="appearance-none bg-white border border-gray-200 rounded-md px-3 py-1.5 pr-8 text-xs font-medium text-gray-700 focus:outline-none focus:ring-1 focus:ring-gray-400 cursor-pointer"
          data-testid="sort-select"
        >
          {SORT_OPTIONS.map(opt => (
            <option key={opt.value} value={opt.value}>{opt.label}</option>
          ))}
        </select>
        <ChevronDown className="absolute right-2 top-1/2 -translate-y-1/2 h-3.5 w-3.5 text-gray-400 pointer-events-none" />
      </div>
    </div>
  );
}
